import React from "react";

// Shopify glyph (brand green). Used in the hero badge and the Who-It's-For card.
export const ShopifyMark = (props) => (
  <svg viewBox="0 0 448 512" aria-hidden="true" {...props}>
    <path
      fill="#95BF46"
      d="M388.3 104.1c-.4-2.6-2.6-4.1-4.5-4.2s-37.4-2.8-37.4-2.8-24.8-24.6-27.5-27.4c-2.7-2.7-8.1-1.9-10.2-1.3-.3 .1-5.4 1.7-13.9 4.3-8.3-23.9-22.9-45.8-48.7-45.8h-2.2C236.7 8.6 227.8 0 220.1 0c-59.9 0-88.5 74.9-97.5 113-23.3 7.2-39.8 12.3-41.9 13-13 4.1-13.4 4.5-15.1 16.7C64.3 151.9 30.2 416.4 30.2 416.4L298 466.5l145-31.4S388.7 106.7 388.3 104.1zM280.8 77.8l-22.4 6.9c0-1.6 .1-3.1 .1-4.8 0-14.5-2-26.2-5.2-35.5 12.9 1.6 21.5 16.3 27.5 33.4zm-44-30.5c3.6 9 5.9 21.9 5.9 39.3 0 .9 0 1.7-.1 2.5-14.6 4.5-30.4 9.4-46.3 14.3 8.9-34.4 25.6-51 40.5-56.1zm-17.8-16.9c2.6 0 5.3 .9 7.8 2.6-19.7 9.3-40.8 32.6-49.7 79.2l-36.6 11.3C148.8 100.5 173.1 30.4 219 30.4z"
    />
    <path
      fill="#5E8E3E"
      d="M383.8 99.9c-1.9-.1-37.4-2.8-37.4-2.8s-24.8-24.6-27.5-27.4c-1-1-2.4-1.5-3.8-1.7L298 466.5l145-31.4S388.7 106.7 388.3 104.1c-.4-2.6-2.6-4.1-4.5-4.2z"
    />
    <path
      fill="#FFF"
      d="M241.1 169.9 223.2 223s-15.8-8.5-35.2-8.5c-28.5 0-29.9 17.9-29.9 22.4 0 24.5 63.9 33.9 63.9 91.3 0 45.2-28.6 74.2-67.3 74.2-46.4 0-70.1-28.9-70.1-28.9l12.4-41s24.4 20.9 45 20.9c13.5 0 18.9-10.6 18.9-18.3 0-32-52.4-33.4-52.4-86 0-44.2 31.7-87 95.8-87 24.7 0 36.9 7.1 36.9 7.1z"
    />
  </svg>
);
